// extracted by css-extract-rspack-plugin
export default {"gate":"AssetsGate-module__gate___sMQy6","invisible":"AssetsGate-module__invisible___DzuIj"};